module.exports = __webpack_public_path__ + "img/savings.f00af2fc.png";